import { useState, useRef, useEffect } from "react";
import { Button } from "./ui/button";
import { MoreVertical, Pencil, History, Trash2 } from "lucide-react";

export default function TaskActionMenu({ task, onEdit, onHistory, onDelete }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [open]);

  const handleAction = (action) => {
    setOpen(false);
    action();
  };

  return (
    <div className="relative" ref={menuRef}>
      <Button 
        variant="ghost" 
        size="icon" 
        className="h-8 w-8 flex-shrink-0"
        onClick={() => setOpen(!open)}
        data-testid={`task-menu-${task.id}`}
      >
        <MoreVertical className="w-4 h-4" />
      </Button>
      
      {open && (
        <div className="absolute right-0 top-full mt-1 z-50 min-w-[150px] bg-popover border border-border rounded-md shadow-lg py-1 animate-in fade-in-0 zoom-in-95">
          <button
            className="w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-secondary transition-colors text-left"
            onClick={() => handleAction(() => onEdit(task))}
            data-testid={`task-edit-${task.id}`}
          >
            <Pencil className="w-4 h-4" />
            Modifica
          </button>
          <button
            className="w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-secondary transition-colors text-left"
            onClick={() => handleAction(() => onHistory(task))}
            data-testid={`task-history-${task.id}`}
          >
            <History className="w-4 h-4" />
            Storico
          </button>
          <button
            className="w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-secondary transition-colors text-left text-destructive"
            onClick={() => handleAction(() => onDelete(task.id))}
            data-testid={`task-delete-${task.id}`}
          >
            <Trash2 className="w-4 h-4" />
            Elimina
          </button>
        </div>
      )}
    </div>
  );
}
